import {
  GET_INSPECTIONS,
  GET_INSPECTIONS_SUCCESS,
  GET_INSPECTIONS_FAIL,
  GET_INSPECTION_DETAILS,
  GET_INSPECTION_DETAILS_SUCCESS,
  GET_INSPECTION_DETAILS_FAIL,
  CREATE_INSPECTION,
  CREATE_INSPECTION_SUCCESS,
  CREATE_INSPECTION_FAIL,
  UPDATE_INSPECTION,
  UPDATE_INSPECTION_SUCCESS,
  UPDATE_INSPECTION_FAIL,
  RESET_INSPECTION_STATE,
  CHECK_INSPECTION_NUMBER,
  CHECK_INSPECTION_NUMBER_FAIL,
  CHECK_INSPECTION_NUMBER_SUCCESS,
  GET_INSPECTIONS_BOOKING,
  GET_INSPECTION_BOOKING_DETAILS,
  CREATE_INSPECTION_BOOKING,
  UPDATE_INSPECTION_BOOKING,
  GET_INSPECTION_BOOKING_DETAILS_FAIL,
  UPDATE_INSPECTION_BOOKING_FAIL,
  CREATE_INSPECTION_BOOKING_FAIL,
  GET_INSPECTIONS_BOOKING_SUCCESS,
  GET_INSPECTION_BOOKING_DETAILS_SUCCESS,
  CREATE_INSPECTION_BOOKING_SUCCESS,
  UPDATE_INSPECTION_BOOKING_SUCCESS,
  DELETE_INSPECTION_SUCCESS,
  DELETE_INSPECTION_FAIL,
  DELETE_INSPECTION,
  PUT_WHATSAPP_SHARE_FAIL,
  PUT_WHATSAPP_SHARE,
  PUT_WHATSAPP_SHARE_SUCCESS,
  PUT_WHATSAPP_SHARE_PDF_SUCCESS,
  PUT_WHATSAPP_SHARE_PDF_FAIL,
  PUT_WHATSAPP_SHARE_PDF,
} from "./actionTypes"

const INIT_STATE = {
  inspections: {
    inspections: [],
    total: "",
    page: "",
  },
  whatsapp: {},
  inspectionDetails: {},
  createInspectionData: {},
  bookingDetails: {},
  inspectionsBooking: {
    inspectionsBooking: [],
    total: "",
    page: "",
  },
  inspectionBookingDetails: {},
  createInspectionBookingData: {},
  error: {},
  loadingCreate: false,

  loading: false,
  loadingWhatsapp: false,
  vehicleNumber: {},
}

const Inspection = (state = INIT_STATE, action) => {
  switch (action.type) {
    // Vehicle - This line cannot be edited or removed
    case GET_INSPECTIONS:
    case GET_INSPECTION_DETAILS:
    case GET_INSPECTIONS_BOOKING:
    case GET_INSPECTION_BOOKING_DETAILS:
    case CHECK_INSPECTION_NUMBER:
    case DELETE_INSPECTION:
    case PUT_WHATSAPP_SHARE:
      return {
        ...state,
        loading: true,
      }
    case CREATE_INSPECTION_BOOKING:
      return {
        ...state,
        loadingCreate: true,
      }
    case UPDATE_INSPECTION_BOOKING:
      return {
        ...state,
        loadingCreate: true,
      }
    case CREATE_INSPECTION:
      return {
        ...state,
        loadingCreate: true,
      }
    case UPDATE_INSPECTION:
      return {
        ...state,
        loadingCreate: true,
      }

    case PUT_WHATSAPP_SHARE_PDF:
      return {
        ...state,
        loadingWhatsapp: true,
      }

    case GET_INSPECTIONS_FAIL:
    case GET_INSPECTION_DETAILS_FAIL:
    case CHECK_INSPECTION_NUMBER_FAIL:
    case GET_INSPECTION_BOOKING_DETAILS_FAIL:
    case DELETE_INSPECTION_FAIL:
    case PUT_WHATSAPP_SHARE_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    case UPDATE_INSPECTION_BOOKING_FAIL:
      return {
        ...state,
        error: action.payload,
        loadingCreate: false,
      }
    case UPDATE_INSPECTION_FAIL:
      return {
        ...state,
        error: action.payload,
        loadingCreate: false,
      }
    case CREATE_INSPECTION_FAIL:
      return {
        ...state,
        error: action.payload,
        loadingCreate: false,
      }
    case CREATE_INSPECTION_BOOKING_FAIL:
      return {
        ...state,
        error: action.payload,
        loadingCreate: false,
      }

    case PUT_WHATSAPP_SHARE_PDF_FAIL:
      return {
        ...state,
        error: action.payload,
        loadingWhatsapp: false,
      }
    case GET_INSPECTIONS_SUCCESS:
      return {
        ...state,
        inspections: action.payload,
        error: {},
        loading: false,
      }
    case GET_INSPECTIONS_BOOKING_SUCCESS:
      return {
        ...state,
        inspectionsBooking: action.payload,
        error: {},
        loading: false,
      }

    case GET_INSPECTION_DETAILS_SUCCESS:
      return {
        ...state,
        inspectionDetails: action.payload,
        error: {},
        loading: false,
      }

    case GET_INSPECTION_BOOKING_DETAILS_SUCCESS:
      return {
        ...state,
        inspectionBookingDetails: action.payload,
        error: {},
        loading: false,
      }

    case CREATE_INSPECTION_SUCCESS:
      return {
        ...state,
    
        inspectionDetails: action.payload,
        createInspectionData: action.payload,
        error: {},
        loadingCreate: false,
      }

    case CREATE_INSPECTION_BOOKING_SUCCESS:
      return {
        ...state,
        
        bookingDetails: action.payload,
        error: {},
        loadingCreate: false,
      }

    case UPDATE_INSPECTION_SUCCESS:
      return {
        ...state,
        loadingCreate: false,
        error: {},
      }

    case UPDATE_INSPECTION_BOOKING_SUCCESS:
      return {
        ...state,

        loadingCreate: false,
        error: {},
      }

    case CHECK_INSPECTION_NUMBER_SUCCESS:
      return {
        ...state,
        vehicleNumber: action.payload,
        error: {},
        loading: false,
      }
    case RESET_INSPECTION_STATE:
      return {
        ...state,
        createInspectionData: {},
        vehicleDetails: {},
      }

    case DELETE_INSPECTION_SUCCESS:
      return {
        ...state,
       
        inspections: {
          ...state.inspections,
          inspectionDocuments: state.inspections.inspectionDocuments.filter(
            item => {
              return !action.payload._id.includes(item._id)
            }
          ),
        },
        error: {},
        loading: false,
      }
    case PUT_WHATSAPP_SHARE_SUCCESS:
      return {
        ...state,
        whatsapp: action.payload,

        error: {},
        loading: false,
      }
    case PUT_WHATSAPP_SHARE_PDF_SUCCESS:
      return {
        ...state,
        whatsapp: action.payload,

        error: {},
        loadingWhatsapp: false,
      }
    default:
      return state
  }
}

export default Inspection
